
        var result = require("!!../../../../../node_modules/css-loader/index.js!./oil-overview.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/oil/oil-overview/oil-overview.component.css
// module id = 719
// module chunks = 0